<template>
    <div class="Result">
        <ul class="Result__list">
            <li>{{ label }} <strong>{{ result }}</strong></li>
            <span v-if="announceResults" class="sr-only" role="alert" aria-live="assertive">Estimate of {{ type }} cover is {{ result }}</span>
        </ul>
        <div class="Result__buttons">
            <button
                class="btn gtm-calculator-reset"
                @click="$emit('reset')"
            >
                Reset
            </button>
            <button
                v-if="type === 'Life'" 
                class="btn btn--teal btn--thin" 
                @click="$modal.show('Assumptions')"
            >
                Adjust assumptions
            </button>
        </div>
        <AssumptionsModal />
    </div>
</template>

<script>
    import AssumptionsModal from '@/components/AssumptionsModal.vue';

    export default {
        components: { AssumptionsModal },

        data: () => ({
            announceResults: false
        }),

        props: {
            url: {
                type: String,
                require: true
            },
            type: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            result: {
                type: String,
                required: true
            }
        },

        mounted() {
            const product = window.location.href.includes('/life/') ? 'life' : 'income';
            this.$store.commit('update', {name: 'product', value: product});

            // Screen reader will only announce results if it isn't alerady ther on page load
            window.setTimeout(() => {
                this.announceResults = true;
            }, 2000);
        }
    }
</script>

<style lang="scss" scoped>
    .Result__list {
        margin-bottom: 10px;
        margin-top: 60px;
        padding: 0;
        list-style: none;
        text-align: left;
        font-size: 18px;
    }
    .Result__list li {
        width: 100%;
        margin-bottom: 1.5em;
        padding-bottom: 0.75em;
        border-bottom: 1px solid rgba(0,0,0,0.2);
    }

    .Result__list strong {
        float: right;
    }
    .Result__buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center; 
        margin-top: 45px;
        
        .btn {
            flex-shrink: 0;
            margin: 5px 15px;
        }
    }

    .Result__modal-link {
        text-decoration: underline;
        display: block;
        margin-top: 20px;
    }
</style>
